<template>
    <div class="UserAgreement xi">
        <nh-com></nh-com>
        <div class="banner">
            <div class="banner-text">
                <h3>个人信息使用授权协议</h3>
                <!-- <p>Ge Ren XI YI</p> -->
            </div>
        </div>
        <div class="agreement-box">
            <div class="agreement-tit">
                <h3>个人信息使用授权协议</h3>
            </div>
            <div class="agreement-content">
                 <div class="disclaimer-container">
                        <div class="disclaimer-content">
                        <p>河南千越医疗科技有限公司通过千越医助手平台为您提供在线问诊、电话问诊、预约挂号等服务。</p>
                        <p>我司深知个人信息的敏感性和重要性，所以我司承诺：我司将会会合法、合理的收集您的个人信息，同时遵守国家相关法律法规要求，使用您的个人信息，并且保证您个人信息的安全。</p>
                        <p>鉴于此，我司特制定《个人信息使用授权协议》，在您使用本平台所有服务前，请您仔细阅读本协议的所有内容。一旦您使用我司提供的服务后，即表示您已知晓并同意本协议的全部内容。如您对本协议内容有疑问、意见或建议，您与我司客服联系，联系电话：0395-3393819。</p>
                        <p>本协议可能会不定期变更，但我司不会削减您所应享有的权利，请您知晓。</p>
                        
                        <h3 class="title">一、名词解释</h3>
                        <p>河南千越医疗科技有限公司：以下简称"我司"、"本公司"或"公司"。</p>
                        <p>本协议可能会不定期变更，但我司不会削减您所应享有的权利，请您知晓。</p>
                        <p>《个人信息使用授权协议》：以下简称"本协议"。</p>
                        
                        <h3 class="title">二、个人信息内容</h3>
                        <p>您的个人信息包括个人基本信息和个人敏感信息。</p>
                        <p>个人信息包括但不限于您的姓名、性别、年龄、职业、职称、地址、手机号等本本台所需要的所有信息。</p>
                        <p>个人敏感信息包括但不限于您的证件类型、身份证号、证件照片、个人银行卡号、学历证书复印件或照片、职称证明、其他相关资格证复印件或照片等信息。</p>
                        <p>当您使用本平台部分服务过程中，平台需开启您设备的相机、麦克风、存储权限等相关的权限，请您知晓并同意。</p>
                        <p>牵涉问诊、诊疗的过程中，需要收集您或者患者的家庭信息、生育信息、诊断疾病或症状、检查检验、用药记录、既往病史、家族病史、过敏史等健康信息，以及个人身体身体信息，包括但不限于身高、体重、体温、体重、心率、血压、血氧、血脂及血糖等，请您知晓并同意。</p>
                        <p>为确保问诊、诊疗全过程的完整，做到全程可监管、可追溯，平台还需要您上传图文信息、视频信息等内容，请您知晓并同意。</p>
                        <p>如牵涉到处方、药品等信息，平台需要保存您的处方信息，包括但不限于医生诊断、药品信息、诊治医师及其科室信息、处方单号、物流配送信息，请您知晓并同意。</p>
                        <p>为了给你提供更加完善的服务，以及您使用本平台的相应功能，平台需要您手动填写、或上传一些的个人信息，包括但不限于您的身份证图片、资质证书照片、学历证书照片等图片或影像资料。</p>
                        <p>为了满足医疗机构对您或者患者的全面了解的要求，请您务必为我们提供准确、详细的所有平台需要的信息。如因您提供的信息有误，而造成的任何错误、损失等由您全部承担，我司不负任何责任。</p>
                        
                        <h3 class="title">三、个人信息安全与保密</h3>
                        <p>我司郑重承诺：对您的个人信息，我司将会履行严格保密制度，建立规范使用规范，采取必要合理的安全保护措施，以保证您的个人信息免于泄露、丢失、损坏，同时也保证，我司将会尽量避免您的个人信息未经授权，就被访问、使用等情况的发生。</p>
                        <p>我们将依照我国相关的法律法规规定，将您的个人信息存储在我国境内、且安全可信的服务器上，同时，您提交的所有个人信息，只会在有效时间内，向相应的医疗机构或个人展示，一旦超过有效时间，我们将对您的个人信息进行匿名化或者加密处理（法律法规另有规定的除外）。</p>
                        <p>如果我司违反法律法规的规定，或未征得您的同意，违法收集、使用、修改您的个人信息，您有权要求我司进行改正。</p>
                        <p>当我司处理您的个人信息时，出现了重大错误或纰漏，或违反了与您的约定，您有权要求我司删除错误的个人信息。</p>
                        <p>当服务期限到期，您不再继续使用平台，请您及时注销您的账户，一面造成不必要的损失。</p>
                        <p>如果我司出现破产、倒闭等重大情况时，我司将终止继续提供服务，同时停止平台的运营。</p>
                        <p>您的任何反馈，我司将在十五个工作日内或法律法规规定的期限内给您答复。如果您对我们的回复不满意，或我司存在损害您合法权益的行为，您可以向相应的监管部门进行投诉或举报。</p>
                        
                        <h3 class="title">四、未成年的个人信息处理</h3>
                        <p>我司所有的产品、网站以及提供的服务主要面向18岁以上的成年人，所以未成年人如果需要使用本平台，必须经过父母或监护人的同意。</p>
                        <p>如果您是未成年人的父母或监护人，您所监护的未成年人使用了我司的服务，并向平台提供的个人用户信息，对此您有任何疑问，请您及时与我司客服联系。我司将根据国家相关法律法规及《隐私政策》的规定，保护未成年人个人用户信息的安全，或者根据相关规定，及时删除未成年人信息。</p>
                        
                        <h3 class="title">五、个人信息的自我管理</h3>
                        <p>您在本平台提交的所有信息，除了本平台保护之外，请您自己也要保护好个人信息，如因您个人行为而造成您的信息泄露，我司不负任何责任。</p>
                        <p>您在有效期内，有权随时访问您的个人信息（法律法规规定的例外情况除外），您可以登录账号，通过"我的"里面对应的功能菜单，查看您的个人信息。</p>
                        <p>如果您发现关于您的个人信息有错误时，请您务必尽快更改错误信息，如果因平台问题，无法更改，您有权与我司客服联系，要求我司做出更正。</p>
                        
                        <div class="footer-space"></div>
                        </div>
                    </div>
            </div>
        </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>
    import ftCom from '../../components/footer';
    import nhCom from "../../components/navheader";
    // import rtBar from "../../components/right";
    export default {
        name: "UserAgreement",
        components: {
            ftCom,
            nhCom,
            // rtBar
        },
    }
</script>

<style scoped>
    .UserAgreement{
        background: #f4f4f4;
    }
    .xi .banner{
        height: 116px;
        background: url("../../assets/img/jbk_banner.png")center no-repeat;
    }
    .banner-text{
        width: 1200px;
        margin: 0 auto;
    }
    .banner-text h3{
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }
    .banner-text p{
        font-size: 18px;
        color: #ffffff;
    }
    .agreement-box {
        margin: 30px auto;
        width: 1200px;
        padding: 20px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #e5e5e5;
    }
    .agreement-tit{
        padding: 10px 0 20px;
        border-bottom: 1px solid #e5e5e5;
    }
    .agreement-tit h3{
        font-size: 20px;
        color: #333333;
        text-align: center;
        font-weight: bold;
    }
    .agreement-content{
        padding: 25px 0;
    }
    .agreement-content p{
        text-indent: 28px;
        line-height: 2;
    }
    .agreement-content p.s-p{
        text-indent: 42px;
    }
    .agreement-content h4{
        text-indent: 28px;
        line-height: 1.7;
        padding: 15px 0;
    }
    .disclaimer-container {
  /* background-color: #f5f5f5; */
  min-height: 100vh;
  padding: 20px 0;
}

.disclaimer-content {
  background-color: #fff;
  padding: 24px;
  margin: 0 auto;
  /* max-width: 800px; */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  border-radius: 8px;
  color: #666;
  /* line-height: 1.6; */
}

.disclaimer-content p {
  margin: 12px 0;
  text-indent: 2em;
  text-align: justify;
}

.title {
  font-weight: 800;
  padding: 20px 0 10px 0;
  color: #333;
  border-bottom: 1px solid #eee;
  margin: 24px 0 16px 0;
}

.footer-space {
  width: 100%;
  height: 50px;
}
</style>

